<script lang="ts">
    import type { Faq } from "$lib/utils/seo-content";

    let { faqs, heading = "Frequently Asked Questions" }: { faqs: Faq[]; heading?: string } = $props();
</script>

{#if faqs.length}
    <section class="mx-auto w-full max-w-3xl px-4 pt-6 pb-10">
        <h2 class="mb-4 text-2xl font-bold">{heading}</h2>
        <div class="flex flex-col gap-2">
            {#each faqs as faq (faq.question)}
                <details class="collapse-arrow collapse bg-base-300">
                    <summary class="collapse-title text-base font-semibold">{faq.question}</summary>
                    <div class="collapse-content text-sm text-base-content/70">
                        <p>{faq.answer}</p>
                    </div>
                </details>
            {/each}
        </div>
    </section>
{/if}
